import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import api from "../../api"; // axios instance (with token + interceptors)

const VendorPage = () => {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    gst_no: "",
  });
  const [items, setItems] = useState([]);
  const [editId, setEditId] = useState(null);
  const [msg, setMsg] = useState(null);
  const [search, setSearch] = useState("");

  const baseURL = "/vendor";

  // 🔹 Fetch all vendors
  const fetchVendors = async () => {
    try {
      const res = await api.get(`${baseURL}/list`);
      const data = res.data;
      setItems(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Error fetching vendors:", err);
      setItems([]);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // 🔹 Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 Submit Add / Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!form.name.trim()) {
      setMsg({ type: "error", text: "Vendor name required" });
      return;
    }

    try {
      let res;
      if (editId) {
        res = await api.post(`${baseURL}/update`, { ...form, id: editId });
      } else {
        res = await api.post(`${baseURL}/add`, form);
      }

      const json = res.data;
      if (json?.status) {
        setMsg({
          type: "success",
          text: json.message || (editId ? "Updated successfully" : "Added successfully"),
        });
        setForm({ name: "", mobile: "", email: "", address: "", gst_no: "" });
        setEditId(null);
        fetchVendors();
      } else {
        setMsg({ type: "error", text: json?.message || "Operation failed" });
      }
    } catch (err) {
      console.error("Error saving vendor:", err);
      setMsg({
        type: "error",
        text: err.response?.data?.message || err.message || "Network error",
      });
    }
  };

  // 🔹 Edit Vendor
  const handleEdit = (item) => {
    setForm({
      name: item.name || "",
      mobile: item.mobile || "",
      email: item.email || "",
      address: item.address || "",
      gst_no: item.gst_no || "",
    });
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // 🔹 Delete Vendor
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this vendor?")) return;
    try {
      const res = await api.post(`${baseURL}/delete`, { id });
      const json = res.data;
      setMsg({
        type: json?.status ? "success" : "error",
        text: json?.message || (json?.status ? "Deleted" : "Delete failed"),
      });
      fetchVendors();
    } catch (err) {
      setMsg({
        type: "error",
        text: err.response?.data?.message || err.message || "Network error",
      });
    }
  };

  // 🔹 Live search filter
  const filteredItems = items.filter((item) =>
    item.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>
        <main style={{ padding: "30px", maxWidth: "1000px", margin: "auto" }}>
          {/* 🔸 Add / Edit Vendor */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>{editId ? "✏️ Edit Vendor" : "➕ Add New Vendor"}</h2>

            {msg && (
              <div
                style={{
                  marginBottom: 12,
                  color: msg.type === "error" ? "#cc0000" : "#166534",
                }}
              >
                {msg.text}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={formGrid}>
                <FormGroup label="Vendor Name">
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                  />
                </FormGroup>

                <FormGroup label="Mobile">
                  <input
                    type="text"
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    style={fullWidthInput}
                    placeholder="e.g. 9876543210"
                  />
                </FormGroup>

                <FormGroup label="Email (optional)">
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    style={fullWidthInput}
                    placeholder="e.g. vendor@mail.com"
                  />
                </FormGroup>

                <FormGroup label="Address (optional)">
                  <input
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    style={fullWidthInput}
                    placeholder="Vendor full address"
                  />
                </FormGroup>

                <FormGroup label="GST No (optional)">
                  <input
                    type="text"
                    name="gst_no"
                    value={form.gst_no}
                    onChange={handleChange}
                    style={fullWidthInput}
                    placeholder="GST number if available"
                  />
                </FormGroup>
              </div>

              <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button type="submit" style={buttonStyle}>
                  {editId ? "Update Vendor" : "Add Vendor"}
                </button>
              </div>
            </form>
          </section>

          {/* 🔸 Search Bar */}
          <div
            style={{
              ...cardStyle,
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaSearch style={{ marginRight: 10, color: "#0077cc" }} />
            <input
              type="text"
              placeholder="Search vendor by name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ ...fullWidthInput, width: "100%" }}
            />
          </div>

          {/* 🔸 Vendor List */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>📋 All Vendors</h2>

            {filteredItems.length === 0 ? (
              <p>No vendors found.</p>
            ) : (
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {filteredItems.map((item, idx) => (
                  <li
                    key={item.id}
                    style={{
                      marginBottom: "15px",
                      padding: "15px",
                      borderRadius: "8px",
                      background: idx % 2 === 0 ? "#f9f9f9" : "#eef3f9",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong style={{ fontSize: "16px", color: "#333" }}>{item.name}</strong>
                      <div style={{ color: "#777", fontSize: "13px" }}>
                        {item.mobile ? `📞 ${item.mobile}` : ""}
                        {item.email ? ` | ✉️ ${item.email}` : ""}
                        {item.gst_no ? ` | GST: ${item.gst_no}` : ""}
                        {item.address ? ` | ${item.address}` : ""}
                      </div>
                    </div>

                    <div>
                      <FaEdit
                        onClick={() => handleEdit(item)}
                        style={{
                          color: "#0077cc",
                          cursor: "pointer",
                          marginRight: "15px",
                        }}
                      />
                      <FaTrash
                        onClick={() => handleDelete(item.id)}
                        style={{ color: "red", cursor: "pointer" }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

// 🔹 Reusable FormGroup
const FormGroup = ({ label, children, style }) => (
  <div style={{ ...style }}>
    <label
      style={{
        marginBottom: "6px",
        display: "block",
        fontWeight: 500,
        color: "#444",
      }}
    >
      {label}
    </label>
    {children}
  </div>
);

// 🔹 Common Styles
const formGrid = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "20px",
};

const fullWidthInput = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "15px",
  boxSizing: "border-box",
};

const buttonStyle = {
  padding: "10px 25px",
  backgroundColor: "#0077cc",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
};

const cardStyle = {
  background: "#ffffff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  marginBottom: "30px",
};

const titleStyle = {
  color: "#0077cc",
  marginBottom: "25px",
};

export default VendorPage;
